export type AffinityProgramStatsLocationState = {
  programId?: string;
  programName?: string;
};

export const getAffinityStatsRouteParams = (
  search: string,
  state?: AffinityProgramStatsLocationState
): Required<AffinityProgramStatsLocationState> => {
  const params = new URLSearchParams(search);
  return {
    programId: state?.programId || params.get("programId") || "",
    programName: state?.programName || params.get("programName") || "",
  };
};

export const sortAffinityInquiriesNewestFirst = <
  T extends { createdAtUtcMilli: number }
>(inquiries: ReadonlyArray<T>): T[] =>
  [...inquiries].sort(
    (first, second) => second.createdAtUtcMilli - first.createdAtUtcMilli
  );

export const mergeAffinityInquiryPages = <
  TInquiry,
  TPage extends {
    inquiries: TInquiry[];
    inquiriesReturnedCount: number;
  }
>({
  previousPage,
  nextPage,
}: {
  previousPage: TPage;
  nextPage: TPage;
}): TPage => ({
  ...nextPage,
  inquiries: [...previousPage.inquiries, ...nextPage.inquiries],
  inquiriesReturnedCount:
    previousPage.inquiriesReturnedCount + nextPage.inquiriesReturnedCount,
});
